import { Button, Image, Modal } from 'antd';
import axios from 'axios';
import { Buffer } from 'buffer';
import { memo, useCallback, useEffect, useState } from 'react';
import { apiUrl } from '../../utils/constants';

const ShowQR = ({
  openModalShowQR,
  handleCancelModalShowQR,
  handleOpenTwoFactor,
}) => {
  const [generateQRResponse, setGenerateQRResponse] = useState(null);

  useEffect(() => {
    const generate = async () => {
      const response = await axios.post(
        `${apiUrl}/2fa/generate`,
        {},
        { responseType: 'arraybuffer' }
      );
      let base64ImageString = Buffer.from(response.data, 'binary').toString(
        'base64'
      );
      setGenerateQRResponse(
        <Image src={'data:image/png;base64,' + base64ImageString} />
      );
    };
    generate();
  }, []);

  const closeModal = useCallback(() => {
    setGenerateQRResponse(null);
    handleCancelModalShowQR();
  }, [handleCancelModalShowQR]);

  const onNext = useCallback(() => {
    handleOpenTwoFactor();
    closeModal();
  }, [closeModal, handleOpenTwoFactor]);

  return (
    <Modal
      open={openModalShowQR}
      title="Step 1/2: Scan QR"
      afterClose={closeModal}
      onCancel={closeModal}
      footer={[
        <Button type="primary" key="next" onClick={onNext}>
          Next step to complete
        </Button>,
      ]}
    >
      {generateQRResponse && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
          }}
        >
          <b>Use Google Authenticator to scan</b>
          {generateQRResponse}
        </div>
      )}
    </Modal>
  );
};

export default memo(ShowQR);
